import { render, staticRenderFns } from "./MySearchBox.vue?vue&type=template&id=5aa37ce4&"
import script from "./MySearchBox.vue?vue&type=script&lang=js&"
export * from "./MySearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports